import * as React from "react";
import type { SVGProps } from "react";

interface MainProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Main = ({ cancelled = false, ...props }: MainProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    viewBox="0 0 66 66"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <g strokeLinejoin="round">
        <path
          fill="#F9A66B"
          stroke="#FFF"
          strokeWidth={3}
          d="M21.57 14.278c4.5-4.477 10.476-7.546 16.615-7.874 5.361-.286 10.867 1.486 15.67 6.263 4.81 4.782 6.591 10.26 6.302 15.595-.33 6.108-3.42 12.055-7.927 16.536a21.6 21.6 0 0 1-11.076 5.89l-.804.102c-1.65.202-2.918.288-3.797.268-2.566-.04-5.127-.483-7.55-1.421-1.267-.221-3.616-.714-4.583.248-1.853 1.842-3.61 4.082-5.067 5.935-1.103 1.402-2.048 2.595-2.75 3.292-1.173 1.166-2.585 1.532-4.099 1.229-1.307-.262-2.735-1.089-4.102-2.45-1.362-1.353-2.18-2.78-2.444-4.08-.311-1.536.066-2.954 1.216-4.098.674-.67 1.856-1.598 3.254-2.685 1.875-1.459 4.162-3.233 6.028-5.088 1.079-1.074.395-3.875.215-4.631-.922-2.384-1.357-4.9-1.401-7.419.075-1.752.185-2.989.358-4.515.833-4.147 2.803-7.98 5.941-11.097Z"
        />
        <path
          stroke="#000"
          strokeWidth={2}
          d="M21.922 14.632c4.412-4.388 10.268-7.407 16.29-7.728 5.233-.28 10.604 1.456 15.29 6.117 4.692 4.665 6.438 10.009 6.156 15.214-.324 5.99-3.363 11.816-7.78 16.209a21.1 21.1 0 0 1-10.805 5.75l-.783.1q-2.43.294-3.729.264c-2.523-.04-5.041-.476-7.423-1.405-1.39-.233-4.001-.687-5.07.377-1.868 1.857-3.639 4.113-5.108 5.981-1.087 1.382-2.018 2.559-2.71 3.246-1.043 1.038-2.3 1.364-3.647 1.094-1.23-.247-2.565-1.037-3.849-2.314-1.278-1.27-2.058-2.603-2.306-3.826-.277-1.365.056-2.626 1.08-3.644.663-.66 1.83-1.573 3.207-2.644 1.89-1.47 4.193-3.259 6.073-5.129 1.213-1.207.494-4.426.34-5.141-.909-2.336-1.335-4.802-1.378-7.272.074-1.708.183-2.935.354-4.45.808-4.01 2.733-7.755 5.798-10.799Z"
        />
      </g>
      <path
        fill="#EA4848"
        d="M52.797 13.73c9.638 9.582 6.26 22.164-1.625 30.005a20.1 20.1 0 0 1-10.26 5.471l-.744.095q-2.308.282-3.564.258l-19.83-19.832.02-.558q.072-1.388.324-3.626a19.9 19.9 0 0 1 5.51-10.202c7.88-7.838 20.537-11.19 30.17-1.61"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Main;
